import { css } from 'linaria';

export const collectionComposition = css`
  && {
    border: 1px solid #e8e9eb;
    border-radius: var(--rounding-l);
  }
`;

export const collectionCompositionDisclaimer = css`
  margin-bottom: 15px;
  border-radius: var(--rounding-l);
  background-color: var(--accent-light);
  padding: 16px;
`;

export const collectionCompositionContent = css`
  display: flex;
  padding: 56px 118px;
  column-gap: 85px;

  @media (--only-desktop) {
    padding: 44px 93px;
    column-gap: 70px;
  }

  @media (--only-tablet) {
    padding: 32px 58px;
    column-gap: 50px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    padding: 24px;
    row-gap: 24px;
  }
`;

export const collectionCompositionImage = css`
  width: 425px;
  height: 319px;
  margin-bottom: 15px;

  @media (--only-tablet) {
    width: 412px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
  }
`;

export const collectionCompositionTextWrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 12px;
  margin-bottom: 15px;
`;

export const collectionCompositionTextRow = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const collectionCompositionText = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
